// Titel, Beschreibung und Tags einer Vorlage in die andere Sprache übersetzen
// lassen (POST /api/v1/translations, Pro, ohne KI-Credit) -- die Anfrage und
// das, was ein abgelehnter Versuch heißt. Zwei Aufrufer: der
// Veröffentlichen-Dialog im Editor und das Bearbeiten-Formular der Vorlage
// (ui/templateTranslate.ts). Das Ergebnis ist immer nur ein Vorschlag für die
// Felder; gespeichert wird, was danach abgeschickt wird.

import { t } from '../i18n'
import { ApiError, apiSendJson } from './api'

export type ContentLanguage = 'de' | 'en'

export type TemplateTexts = { title: string; description: string; tags: string[] }

export async function requestTemplateTranslation(
  from: ContentLanguage,
  to: ContentLanguage,
  texts: TemplateTexts,
): Promise<TemplateTexts> {
  return apiSendJson<TemplateTexts>('/api/v1/translations', 'POST', { from, to, ...texts })
}

export function translateErrorMessage(caught: unknown): string {
  if (caught instanceof ApiError) {
    if (caught.status === 403) return t('publish.translatePro')
    if (caught.status === 429) return t('publish.translateLimit')
    if (caught.status === 503) return t('publish.translateUnavailable')
  }
  return t('publish.translateFailed')
}
